export const data = {
  internalName: 'Product Segmented Nav Header',
  id: 'psHeader',
  navHeaderLogo: {
    metadata: {
      tags: [],
    },
    sys: {
      space: {
        sys: {
          type: 'Link',
          linkType: 'Space',
          id: '2rrb5ka4jpe4',
        },
      },
      id: '7BI7hqgNS8lfW3j277vflZ',
      type: 'Asset',
      createdAt: '2023-01-11T13:19:24.846Z',
      updatedAt: '2023-03-23T13:50:46.985Z',
      environment: {
        sys: {
          id: 'master',
          type: 'Link',
          linkType: 'Environment',
        },
      },
      revision: 12,
      locale: 'en-US',
    },
    fields: {
      title: 'Nav Header Logo',
      description: 'Verto - Nav Header Logo',
      file: {
        url: '//images.ctfassets.net/2rrb5ka4jpe4/7BI7hqgNS8lfW3j277vflZ/96e8cce679b5e6703440964f8be9cb65/Logo_3_.svg',
        details: {
          size: 5922,
          image: {
            width: 82,
            height: 25,
          },
        },
        fileName: 'Logo(3).svg',
        contentType: 'image/svg+xml',
      },
    },
  },
  navHeaderColumn: [
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '2rrb5ka4jpe4',
          },
        },
        id: '6JHP7lQlbiT5RtjVu82sjI',
        type: 'Entry',
        createdAt: '2024-07-09T06:47:46.359Z',
        updatedAt: '2024-07-10T10:57:50.868Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'headerColumn',
          },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 1',
        id: 'psNavHeaderColumn1',
        title: 'Products',
        headerSubsectionReference: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '6l8lYfx2u5AfQQAASzvEHU',
              type: 'Entry',
              createdAt: '2024-07-09T06:38:48.765Z',
              updatedAt: '2024-07-09T07:24:26.380Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 4,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 11',
              subSectionTitle: 'PRODUCTS',
              linkType: '_blank',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4SEQ88KlBmCQIiMOIBYEbD',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:37:46.915Z',
                    updatedAt: '2024-07-09T06:37:46.915Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 111',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6S0xi7J5k1YvpLLTzCEuAY',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:35:33.877Z',
                        updatedAt: '2024-07-09T06:35:33.877Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Business Accounts Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6S0xi7J5k1YvpLLTzCEuAY/5cda99cafd9b65f8aed1a68cad62c7cc/Icon.svg',
                          details: {
                            size: 2819,
                            image: {
                              width: 44,
                              height: 45,
                            },
                          },
                          fileName: 'Icon.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'BUSINESS ACCOUNTS',
                    shortDescription:
                      'Expand globally with multi-currency accounts',
                    linkType: '_self',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'JzEAZ94yDRZESoqZt3OXJ',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:42:37.904Z',
                    updatedAt: '2024-07-09T06:42:37.904Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 112',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '1N7xZuMOVmJKg0NAT31v9U',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:42:08.883Z',
                        updatedAt: '2024-07-09T06:42:08.883Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Expense Management Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/1N7xZuMOVmJKg0NAT31v9U/3c79ae8356ffdd000583bc5c9951730e/Icon__1_.svg',
                          details: {
                            size: 1161,
                            image: {
                              width: 44,
                              height: 45,
                            },
                          },
                          fileName: 'Icon (1).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'EXPENSES MANAGMENT',
                    shortDescription: 'Streamline your global expense control',
                    linkType: '_self',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1YemUJfyWQBHPB3on2AsnG',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:44:16.472Z',
                    updatedAt: '2024-07-09T06:44:16.472Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 113',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4U9yYFuiNDX1ktWZDcSdCj',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:43:33.351Z',
                        updatedAt: '2024-07-09T06:43:33.351Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'FX & Treasury Management Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4U9yYFuiNDX1ktWZDcSdCj/ac32ce3a0bcf53f2a836a319ff82bfd9/Icon__2_.svg',
                          details: {
                            size: 7698,
                            image: {
                              width: 44,
                              height: 45,
                            },
                          },
                          fileName: 'Icon (2).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'FX & TREASURY MANAGEMENT',
                    shortDescription: 'Master currency and treasury management',
                    linkType: '_self',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4H6G9e4ClUvcdZwDicS8NB',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:46:06.871Z',
                    updatedAt: '2024-07-09T06:46:06.871Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 114',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3fde9RlW7lbcizsKReBze9',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:45:05.428Z',
                        updatedAt: '2024-07-09T06:45:05.428Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Invoice Payments Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3fde9RlW7lbcizsKReBze9/93d2ab5e22093d154e8c71c5112bc892/Icon__3_.svg',
                          details: {
                            size: 4137,
                            image: {
                              width: 44,
                              height: 45,
                            },
                          },
                          fileName: 'Icon (3).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'INVOICE PAYMENTS',
                    shortDescription: 'Simplify your global invoice processing',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '7vLQQXuZBffMgY7Fmu9bMm',
              type: 'Entry',
              createdAt: '2024-07-09T07:23:05.076Z',
              updatedAt: '2024-07-09T07:24:53.984Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 12',
              subSectionTitle: 'PLATFORM',
              linkType: '_blank',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1RiyqgoVQ0c2Kcpw2dWRvP',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:47:29.995Z',
                    updatedAt: '2024-07-09T06:47:29.995Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 121',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6xLgZZSRjUwCjzPIFnHJ8R',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:46:56.034Z',
                        updatedAt: '2024-07-09T06:46:56.034Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Core APIs Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6xLgZZSRjUwCjzPIFnHJ8R/db07c12e82d9792707c526b70da4423f/Icon__4_.svg',
                          details: {
                            size: 1459,
                            image: {
                              width: 45,
                              height: 45,
                            },
                          },
                          fileName: 'Icon (4).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'CORE APIs',
                    shortDescription:
                      'Build on our banking and payments infrastructure',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: 'fDKl3uhnUM5erm3X0vF3X',
              type: 'Entry',
              createdAt: '2024-07-09T07:25:55.092Z',
              updatedAt: '2024-07-09T07:29:11.133Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 13',
              subSectionTitle: 'PRODUCT ANNOUNCEMENTS',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1WN4D0FdPaQKGHYfAlFD72',
                    type: 'Entry',
                    createdAt: '2024-07-09T07:28:07.887Z',
                    updatedAt: '2024-07-09T07:28:07.887Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 131',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'l8TPaMHNwXoxMgfvbTS52',
                        type: 'Asset',
                        createdAt: '2024-07-09T07:27:00.738Z',
                        updatedAt: '2024-07-09T07:27:00.738Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Marketplace Product Announcement',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/l8TPaMHNwXoxMgfvbTS52/31af563ea5b1a9969005b09323161dfb/BA.svg',
                          details: {
                            size: 1184393,
                            image: {
                              width: 417,
                              height: 204,
                            },
                          },
                          fileName: 'BA.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Introducing Verto Marketplace',
                    shortDescription:
                      'Negotiate and exchange currencies at your desired rates on our game-changer in currency exchange : Marketplace.',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '2rrb5ka4jpe4',
          },
        },
        id: '4s1a6GYeU4U2GIYeHNDvor',
        type: 'Entry',
        createdAt: '2024-07-09T15:36:57.370Z',
        updatedAt: '2024-07-09T15:36:57.370Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'headerColumn',
          },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 2',
        id: 'psNavHeaderColumn2',
        title: 'Solutions',
        headerSubsectionReference: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '6eNkL1CKc7d1igOyBpBNXQ',
              type: 'Entry',
              createdAt: '2024-07-09T15:31:52.490Z',
              updatedAt: '2024-07-09T15:31:52.490Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 21',
              subSectionTitle: 'BY STAGE',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2TtFrXwXlitLVptNvOgtPu',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:31:55.268Z',
                    updatedAt: '2024-07-09T15:53:53.562Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 211',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6mmXt8ucuZeUhSL5FbrXlL',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:50:54.492Z',
                        updatedAt: '2024-07-09T15:51:04.483Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Startups',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6mmXt8ucuZeUhSL5FbrXlL/0c0d05ee243d41fc6ca69026d7d0b18b/image.png',
                          details: {
                            size: 499,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'image.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Startups',
                    shortDescription:
                      'Go global with our Multi-currency Business Account and Debit Card',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Start-up ',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '77ymgeHSWtah5V9iCQwBt3',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:31:58.720Z',
                    updatedAt: '2024-07-09T15:54:19.070Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 212',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'ihmbvjgL0ILKarfwA7Fgn',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:54:14.728Z',
                        updatedAt: '2024-07-09T15:54:14.728Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Scale Up Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/ihmbvjgL0ILKarfwA7Fgn/316b37414d64016a68217480cc87cd66/Scale_Up_Icon.png',
                          details: {
                            size: 687,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Scale Up Icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Mid-Size Companies',
                    shortDescription:
                      'Elevate your operations with integrated Expense Management ',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Scale-up',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2cNiiUM2hX9JgquEUWdYpJ',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:01.735Z',
                    updatedAt: '2024-07-09T15:54:52.131Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 213',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6PgcXgEuxKwVsbul6nYLt',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:54:48.681Z',
                        updatedAt: '2024-07-09T15:54:48.681Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Bank icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6PgcXgEuxKwVsbul6nYLt/b6040758bc0094df9beff96f4675c6c8/Bank_icon.png',
                          details: {
                            size: 433,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Bank icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Enterprise',
                    shortDescription:
                      'Navigate complex markets confidently with our FX & Treasury Management',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Enterprises',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '2jDHpMsTE5ozGf7T4ZtSck',
              type: 'Entry',
              createdAt: '2024-07-09T15:33:31.397Z',
              updatedAt: '2024-07-09T15:33:31.397Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 22',
              subSectionTitle: 'BY USE CASE',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6ioRXfzNjEtG7HzlILcAhr',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:23.698Z',
                    updatedAt: '2024-07-09T16:01:14.989Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 221',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5l2MqOuqt8S7a65XB0IYHI',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:01:11.118Z',
                        updatedAt: '2024-07-09T16:01:11.118Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'User icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5l2MqOuqt8S7a65XB0IYHI/b05f063cc0b0067aeeec70f3250c9450/User_icon.png',
                          details: {
                            size: 499,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'User icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Creator Economy',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Creator-Economy',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1vUy3HgabQoaQnv5a7TouZ',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:33.069Z',
                    updatedAt: '2024-07-09T16:01:36.729Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 222',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'cO1lTWlTTiVMNk4n1mwIM',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:01:33.128Z',
                        updatedAt: '2024-07-09T16:01:33.128Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Document icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/cO1lTWlTTiVMNk4n1mwIM/6fd4411748056f45bdd4c4eab32fb319/Document_icon.png',
                          details: {
                            size: 486,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Document icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Global Payroll',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Global-Payroll',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '471DzKgwQrwTtb1jy0ZtAd',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:41.985Z',
                    updatedAt: '2024-07-09T16:02:05.124Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 223',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5Tuf9XwYoioAtsW9OMoU68',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:01.352Z',
                        updatedAt: '2024-07-09T16:02:01.352Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Cog Alt Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5Tuf9XwYoioAtsW9OMoU68/b977466fa997fee37d23366aac6de3a6/Cog_Alt_Icon.png',
                          details: {
                            size: 580,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Cog Alt Icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Infrastructure & Construction',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Construction/',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6nVffhU1QkLdqBtuT5tP4Y',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:51.293Z',
                    updatedAt: '2024-07-09T16:02:22.607Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 224',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5QcE7nEuNFPXV8UQffMAGE',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:19.520Z',
                        updatedAt: '2024-07-09T16:02:19.520Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Truck icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5QcE7nEuNFPXV8UQffMAGE/aff6822d2d92fea3da36b4352b0efec2/Truck_icon.png',
                          details: {
                            size: 503,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Truck icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Logistics & Distribution',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Logistics',
                  },
                },
              ],
              linkedPagesReference2: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1zurgyJCpoUwyZCZ0M1UzA',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:02.853Z',
                    updatedAt: '2024-07-09T16:02:42.692Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 225',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'N5PXm6LItvXH5aAqhyESo',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:39.797Z',
                        updatedAt: '2024-07-09T16:02:39.797Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Store icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/N5PXm6LItvXH5aAqhyESo/b2604287b7bdafa1e77208f1b1e568af/Store_icon.png',
                          details: {
                            size: 652,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Store icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Marketplaces',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Marketplaces',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '7gJaYB0b7AhL0jNby90vW8',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:12.684Z',
                    updatedAt: '2024-07-09T16:03:02.067Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 226',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6tt3wU0yIvqQjT3Qee6Iig',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:59.114Z',
                        updatedAt: '2024-07-09T16:02:59.114Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Factory icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6tt3wU0yIvqQjT3Qee6Iig/0cde10e3f2e83a2acfc8b57b8d520568/Factory_icon.png',
                          details: {
                            size: 558,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Factory icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Manufacturing',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Manufacturing',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6TqkmWznhNGLqeRLCjyjT5',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:25.273Z',
                    updatedAt: '2024-07-09T16:03:20.048Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 227',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3eufhj78CbLuSSPvs87Q4O',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:03:17.012Z',
                        updatedAt: '2024-07-09T16:03:17.012Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Desktop Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3eufhj78CbLuSSPvs87Q4O/1f833d23294df028054bd744e5d49458/Desktop_Icon.png',
                          details: {
                            size: 401,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Desktop Icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Online Retail',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Online-Retail',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '5kodr8H85wjbTitLXqKcy',
              type: 'Entry',
              createdAt: '2024-07-09T15:36:53.317Z',
              updatedAt: '2024-07-09T16:06:41.831Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 23',
              subSectionTitle: 'BY INDUSTRIES',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '42epo1TtIWpCWXkxj1le6I',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:35:46.316Z',
                    updatedAt: '2024-07-09T16:03:50.177Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 231',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3OK56A5aDcApVRsklglXim',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:03:47.503Z',
                        updatedAt: '2024-07-09T16:03:47.503Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Love icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3OK56A5aDcApVRsklglXim/fa04ff2026aa96541107882210121f50/Love_icon.png',
                          details: {
                            size: 483,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Love icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Charities & NGOs',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Charities-and-Non-Govermental-Organisations',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1qFY1eqL5KHyKH1nrKJ8ci',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:35:57.041Z',
                    updatedAt: '2024-07-09T16:04:13.069Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 232',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '7lreJ3Zl5q4t46TntivtZu',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:08.649Z',
                        updatedAt: '2024-07-09T16:04:08.649Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'School icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/7lreJ3Zl5q4t46TntivtZu/7ee94993b47f21b859334248e8692bec/School_icon.png',
                          details: {
                            size: 592,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'School icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Educational Institution',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Educational-Institutions',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2kGYWwxn0kOhmB6vCfWGcH',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:07.862Z',
                    updatedAt: '2024-07-09T16:04:31.457Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 233',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6Ft2MShev6RfUCX0Ttti8I',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:27.493Z',
                        updatedAt: '2024-07-09T16:04:27.493Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Export icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6Ft2MShev6RfUCX0Ttti8I/544f53991e9b084966abc74738948a20/Export_icon.png',
                          details: {
                            size: 450,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Export icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Exporters',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Exporters',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6670fo0nefiodbxvlVND1x',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:13.249Z',
                    updatedAt: '2024-07-09T16:04:51.009Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 234',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '17lxoPg1iJa7AUkEyNh54E',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:48.353Z',
                        updatedAt: '2024-07-09T16:04:48.353Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Health icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/17lxoPg1iJa7AUkEyNh54E/09dca7f774d201b682de649330952bc9/Health_icon.png',
                          details: {
                            size: 515,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Health icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Health & Pharmaceutical',
                    linkType: '_self',
                  },
                },
              ],
              linkedPagesReference2: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '62Z11bO6q0aAiZcBBIbadD',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:22.879Z',
                    updatedAt: '2024-07-09T16:05:16.587Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 235',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'uZ0E9uBhnZhm6M6xEsWm1',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:05:13.659Z',
                        updatedAt: '2024-07-09T16:05:13.659Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Import icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/uZ0E9uBhnZhm6M6xEsWm1/111408bb9dc93223b857c3614e078708/Import_icon.png',
                          details: {
                            size: 432,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Import icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Importers',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Importers',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2IyXGc5AExQvJRskydhNNi',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:34.589Z',
                    updatedAt: '2024-07-09T16:05:39.825Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 236',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '7KuN5RDS7eI3mxdHdel6pU',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:05:36.772Z',
                        updatedAt: '2024-07-09T16:05:36.772Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Video icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/7KuN5RDS7eI3mxdHdel6pU/5148898983226ac514dfa71a11d6d95f/Video_icon.png',
                          details: {
                            size: 458,
                            image: {
                              width: 25,
                              height: 24,
                            },
                          },
                          fileName: 'Video icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Media & Communications',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Telecommunications',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5CJi4mZ1qEznzYmp3cRcj6',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:46.410Z',
                    updatedAt: '2024-07-09T16:06:38.725Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 237',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5EXlAtU0UzYXTSnfFlblmj',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:06:35.635Z',
                        updatedAt: '2024-07-09T16:06:35.635Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Plane icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5EXlAtU0UzYXTSnfFlblmj/d38db76d8634a8d060f70eb8dc3a53cd/Plane_icon.png',
                          details: {
                            size: 524,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Plane icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Travel & Tourism',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Travel-and-Tourism',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '2rrb5ka4jpe4',
          },
        },
        id: '5ps6oLpTuPZM2bpCfqySJm',
        type: 'Entry',
        createdAt: '2024-07-09T15:39:07.372Z',
        updatedAt: '2024-07-09T15:39:07.372Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'headerColumn',
          },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 5',
        id: 'psNavHeaderColumn5',
        title: 'Company',
        headerSubsectionReference: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '1sYuJZhRaVqi29ffwor4j5',
              type: 'Entry',
              createdAt: '2024-07-09T15:37:41.297Z',
              updatedAt: '2024-07-09T15:37:41.297Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 51',
              subSectionTitle: 'Company',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '3R0T5s6HSwUmOtFKADIBgz',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:21.894Z',
                    updatedAt: '2024-07-10T11:36:05.240Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 511',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5kpkXnudi7HKcWQXCbqLrL',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:35:58.359Z',
                        updatedAt: '2024-07-10T11:35:58.359Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Verto Circle Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5kpkXnudi7HKcWQXCbqLrL/2d33594d0ce1eafb28b14d086916ff01/Versto_Circle_Icon.png',
                          details: {
                            size: 610,
                            image: {
                              width: 25,
                              height: 24,
                            },
                          },
                          fileName: 'Versto Circle Icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'About Verto',
                    shortDescription: 'Learn more about Verto',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/About-Us',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'hy2uFh0N5g33j8ZLXjeSg',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:29.591Z',
                    updatedAt: '2024-07-10T11:36:26.634Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 512',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5992I98Y0TCHdudqyYKU4a',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:36:21.882Z',
                        updatedAt: '2024-07-10T11:36:21.882Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Verto careers',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5992I98Y0TCHdudqyYKU4a/296bd19d73ac59f45ef5eb5cad3ff91d/Briefcase_icon.png',
                          details: {
                            size: 711,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Briefcase icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Careers',
                    shortDescription: 'Join our awesome team',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/Careers',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4gATifxKFQA2coAo1NT98X',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:38.253Z',
                    updatedAt: '2024-07-10T11:37:49.234Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 513',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6snGpydGRyErhtj7pVlccs',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:37:31.244Z',
                        updatedAt: '2024-07-10T11:37:31.244Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Group icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6snGpydGRyErhtj7pVlccs/9a355e11fc388290f37f622586f68359/Group_icon.png',
                          details: {
                            size: 641,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Group icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Partner',
                    shortDescription: 'Join our partnership program',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/Partners',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: 'RHLn1J5LATXIPPqbx9PNC',
              type: 'Entry',
              createdAt: '2024-07-09T15:38:16.245Z',
              updatedAt: '2024-07-09T15:38:16.245Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 52',
              subSectionTitle: 'Resources',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5JRYP40XdNRr3AFiwkUMe8',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:54.344Z',
                    updatedAt: '2024-07-10T11:38:21.517Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 521',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'nstogbT6X6tSFC975HAqi',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:38:17.496Z',
                        updatedAt: '2024-07-10T11:38:17.496Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Edit icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/nstogbT6X6tSFC975HAqi/2cfa422459ed299f23d814775f7eb352/Edit_icon.png',
                          details: {
                            size: 474,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Edit icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Blog',
                    shortDescription: 'Explore industry and product insight',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Blog',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1WEY4krxVQKCGv5jaMiKGi',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:05.981Z',
                    updatedAt: '2024-07-10T11:38:40.838Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 522',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3vpJUFLCkSj9oqVdWfCRR8',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:38:37.580Z',
                        updatedAt: '2024-07-10T11:38:37.580Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Lifebuoy icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3vpJUFLCkSj9oqVdWfCRR8/19a864e26f126ac21fbc1fb94dd2f08c/Lifebuoy_icon.png',
                          details: {
                            size: 641,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Lifebuoy icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Support',
                    shortDescription: 'Connect with our support team',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Support',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5iOy42o2RQDstW4eqASnI5',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:14.082Z',
                    updatedAt: '2024-07-10T11:39:07.473Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 523',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '2ujAwqHOuahU0kgOKGjBG0',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:04.397Z',
                        updatedAt: '2024-07-10T11:39:04.397Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Document icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/2ujAwqHOuahU0kgOKGjBG0/3b0334d60f604a4935177623fb305d05/Document_icon.png',
                          details: {
                            size: 486,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Document icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Whitepapers & Reports',
                    shortDescription: 'Explore exclusive research and reports',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Whitepapers-and-Reports',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: {
              tags: [],
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: '2rrb5ka4jpe4',
                },
              },
              id: '2Ie0scikvixMw1tLLgU6kM',
              type: 'Entry',
              createdAt: '2024-07-09T15:39:02.596Z',
              updatedAt: '2024-07-09T15:39:02.596Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment',
                },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 53',
              subSectionTitle: 'News & Media',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2G9k0pSgJOYC6jg4oZq2sY',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:29.543Z',
                    updatedAt: '2024-07-10T11:39:36.657Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 531',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'alf7igqsNlzgA6EVcTorX',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:32.400Z',
                        updatedAt: '2024-07-10T11:39:32.400Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Receipt icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/alf7igqsNlzgA6EVcTorX/5d41c54e9c976e68700d3018f1765680/Receipt_icon.png',
                          details: {
                            size: 434,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Receipt icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Newsroom',
                    shortDescription: 'Latest news on Verto',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Newsroom',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'ckrJ5uBge3dZnsPTHwZSA',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:38.465Z',
                    updatedAt: '2024-07-10T11:39:56.167Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 532',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6mpEpMfztUMINSXHHrtVW5',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:53.375Z',
                        updatedAt: '2024-07-10T11:39:53.375Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Events icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6mpEpMfztUMINSXHHrtVW5/300832a81fd91cde85ebbe1e8b6dcf14/Events_icon.png',
                          details: {
                            size: 621,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Events icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Events',
                    shortDescription: 'Meet our team at an event near you',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Events',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '7tY9i08Xcdy79V9uWBMLDB',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:47.508Z',
                    updatedAt: '2024-07-10T11:40:13.464Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 533',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'zAZiKeCGqCnnGf3oVOexH',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:40:09.941Z',
                        updatedAt: '2024-07-10T11:40:09.941Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Microphone icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/zAZiKeCGqCnnGf3oVOexH/47965d57220e7a7c9df2a8fa0d3f0360/Microphone_icon.png',
                          details: {
                            size: 613,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Microphone icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Webinars & Podcasts',
                    shortDescription: 'Listen to global business leaders',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Webinars-and-Podcasts',
                  },
                },
                {
                  metadata: {
                    tags: [],
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6BTCQ2NJZrVpqQIPjJsA5X',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:56.692Z',
                    updatedAt: '2024-07-10T11:40:30.755Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 534',
                    subSectionIcon: {
                      metadata: {
                        tags: [],
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6AEtgQwFc2gK0uJoq1ZX3w',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:40:26.441Z',
                        updatedAt: '2024-07-10T11:40:26.441Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Story icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6AEtgQwFc2gK0uJoq1ZX3w/cb85fafa35728428941d8d31cf7bf2c3/Story_icon.png',
                          details: {
                            size: 533,
                            image: {
                              width: 24,
                              height: 24,
                            },
                          },
                          fileName: 'Story icon.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Customer Stories',
                    shortDescription: 'Success stories from Verto users',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Customer-Stories',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
  ],
  button: [
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '2rrb5ka4jpe4',
          },
        },
        id: '3MkNo4lVVSY6eSF63rmmj6',
        type: 'Entry',
        createdAt: '2023-01-19T08:59:05.104Z',
        updatedAt: '2023-02-13T12:16:27.161Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'button',
          },
        },
        locale: 'en-US',
      },
      fields: {
        buttonId: 'login',
        buttonTitle: 'Login',
        buttonText: 'Login',
        actionType: '_self',
        screenName: 'Login Screen',
        redirectLink: 'https://exchange.verto.co/auth/login',
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '2rrb5ka4jpe4',
          },
        },
        id: 'YE8NTzC1durNYtdZklB8W',
        type: 'Entry',
        createdAt: '2022-12-27T08:24:42.314Z',
        updatedAt: '2024-02-27T16:31:04.320Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 10,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'button',
          },
        },
        locale: 'en-US',
      },
      fields: {
        buttonId: 'getStarted',
        buttonTitle: 'Get started',
        buttonText: 'Get started',
        actionType: '_self',
        screenName: 'Login/Signup',
        redirectLink: 'https://exchange.verto.co/auth/register',
      },
    },
  ],
};

export const data2 = {
  internalName: 'Product Segmented Nav Header',
  id: 'psHeader',
  navHeaderLogo: {
    metadata: { tags: [] },
    sys: {
      space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
      id: '7BI7hqgNS8lfW3j277vflZ',
      type: 'Asset',
      createdAt: '2023-01-11T13:19:24.846Z',
      updatedAt: '2023-03-23T13:50:46.985Z',
      environment: {
        sys: { id: 'master', type: 'Link', linkType: 'Environment' },
      },
      revision: 12,
      locale: 'en-US',
    },
    fields: {
      title: 'Nav Header Logo',
      description: 'Verto - Nav Header Logo',
      file: {
        url: '//images.ctfassets.net/2rrb5ka4jpe4/7BI7hqgNS8lfW3j277vflZ/96e8cce679b5e6703440964f8be9cb65/Logo_3_.svg',
        details: { size: 5922, image: { width: 82, height: 25 } },
        fileName: 'Logo(3).svg',
        contentType: 'image/svg+xml',
      },
    },
  },
  navHeaderColumn: [
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: '6JHP7lQlbiT5RtjVu82sjI',
        type: 'Entry',
        createdAt: '2024-07-09T06:47:46.359Z',
        updatedAt: '2024-08-02T07:11:34.425Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 7,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'headerColumn' },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 1',
        id: 'psNavHeaderColumn1',
        title: 'Products',
        headerSubsectionReference: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '6l8lYfx2u5AfQQAASzvEHU',
              type: 'Entry',
              createdAt: '2024-07-09T06:38:48.765Z',
              updatedAt: '2024-07-09T07:24:26.380Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 4,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 11',
              subSectionTitle: 'PRODUCTS',
              linkType: '_blank',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4SEQ88KlBmCQIiMOIBYEbD',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:37:46.915Z',
                    updatedAt: '2024-07-09T06:37:46.915Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 111',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6S0xi7J5k1YvpLLTzCEuAY',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:35:33.877Z',
                        updatedAt: '2024-07-09T06:35:33.877Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Business Accounts Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6S0xi7J5k1YvpLLTzCEuAY/5cda99cafd9b65f8aed1a68cad62c7cc/Icon.svg',
                          details: {
                            size: 2819,
                            image: { width: 44, height: 45 },
                          },
                          fileName: 'Icon.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'BUSINESS ACCOUNTS',
                    shortDescription:
                      'Expand globally with multi-currency accounts',
                    linkType: '_self',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'JzEAZ94yDRZESoqZt3OXJ',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:42:37.904Z',
                    updatedAt: '2024-07-09T06:42:37.904Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 112',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '1N7xZuMOVmJKg0NAT31v9U',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:42:08.883Z',
                        updatedAt: '2024-07-09T06:42:08.883Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Expense Management Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/1N7xZuMOVmJKg0NAT31v9U/3c79ae8356ffdd000583bc5c9951730e/Icon__1_.svg',
                          details: {
                            size: 1161,
                            image: { width: 44, height: 45 },
                          },
                          fileName: 'Icon (1).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'EXPENSES MANAGMENT',
                    shortDescription: 'Streamline your global expense control',
                    linkType: '_self',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1YemUJfyWQBHPB3on2AsnG',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:44:16.472Z',
                    updatedAt: '2024-07-09T06:44:16.472Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 113',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4U9yYFuiNDX1ktWZDcSdCj',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:43:33.351Z',
                        updatedAt: '2024-07-09T06:43:33.351Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'FX & Treasury Management Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4U9yYFuiNDX1ktWZDcSdCj/ac32ce3a0bcf53f2a836a319ff82bfd9/Icon__2_.svg',
                          details: {
                            size: 7698,
                            image: { width: 44, height: 45 },
                          },
                          fileName: 'Icon (2).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'FX & TREASURY MANAGEMENT',
                    shortDescription: 'Master currency and treasury management',
                    linkType: '_self',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4H6G9e4ClUvcdZwDicS8NB',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:46:06.871Z',
                    updatedAt: '2024-07-09T06:46:06.871Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 114',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3fde9RlW7lbcizsKReBze9',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:45:05.428Z',
                        updatedAt: '2024-07-09T06:45:05.428Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Invoice Payments Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3fde9RlW7lbcizsKReBze9/93d2ab5e22093d154e8c71c5112bc892/Icon__3_.svg',
                          details: {
                            size: 4137,
                            image: { width: 44, height: 45 },
                          },
                          fileName: 'Icon (3).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'INVOICE PAYMENTS',
                    shortDescription: 'Simplify your global invoice processing',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '7vLQQXuZBffMgY7Fmu9bMm',
              type: 'Entry',
              createdAt: '2024-07-09T07:23:05.076Z',
              updatedAt: '2024-07-09T07:24:53.984Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 12',
              subSectionTitle: 'PLATFORM',
              linkType: '_blank',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1RiyqgoVQ0c2Kcpw2dWRvP',
                    type: 'Entry',
                    createdAt: '2024-07-09T06:47:29.995Z',
                    updatedAt: '2024-07-09T06:47:29.995Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 121',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6xLgZZSRjUwCjzPIFnHJ8R',
                        type: 'Asset',
                        createdAt: '2024-07-09T06:46:56.034Z',
                        updatedAt: '2024-07-09T06:46:56.034Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Core APIs Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6xLgZZSRjUwCjzPIFnHJ8R/db07c12e82d9792707c526b70da4423f/Icon__4_.svg',
                          details: {
                            size: 1459,
                            image: { width: 45, height: 45 },
                          },
                          fileName: 'Icon (4).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'CORE APIs',
                    shortDescription:
                      'Build on our banking and payments infrastructure',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: 'fDKl3uhnUM5erm3X0vF3X',
              type: 'Entry',
              createdAt: '2024-07-09T07:25:55.092Z',
              updatedAt: '2024-07-09T07:29:11.133Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 13',
              subSectionTitle: 'PRODUCT ANNOUNCEMENTS',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1WN4D0FdPaQKGHYfAlFD72',
                    type: 'Entry',
                    createdAt: '2024-07-09T07:28:07.887Z',
                    updatedAt: '2024-07-09T07:28:07.887Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 131',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'l8TPaMHNwXoxMgfvbTS52',
                        type: 'Asset',
                        createdAt: '2024-07-09T07:27:00.738Z',
                        updatedAt: '2024-07-09T07:27:00.738Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Marketplace Product Announcement',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/l8TPaMHNwXoxMgfvbTS52/31af563ea5b1a9969005b09323161dfb/BA.svg',
                          details: {
                            size: 1184393,
                            image: { width: 417, height: 204 },
                          },
                          fileName: 'BA.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Introducing Verto Marketplace',
                    shortDescription:
                      'Negotiate and exchange currencies at your desired rates on our game-changer in currency exchange : Marketplace.',
                    linkType: '_self',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: '4s1a6GYeU4U2GIYeHNDvor',
        type: 'Entry',
        createdAt: '2024-07-09T15:36:57.370Z',
        updatedAt: '2024-07-09T15:36:57.370Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 1,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'headerColumn' },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 2',
        id: 'psNavHeaderColumn2',
        title: 'Solutions',
        headerSubsectionReference: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '6eNkL1CKc7d1igOyBpBNXQ',
              type: 'Entry',
              createdAt: '2024-07-09T15:31:52.490Z',
              updatedAt: '2024-07-09T15:31:52.490Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 21',
              subSectionTitle: 'BY STAGE',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2TtFrXwXlitLVptNvOgtPu',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:31:55.268Z',
                    updatedAt: '2024-07-09T15:53:53.562Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 211',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6mmXt8ucuZeUhSL5FbrXlL',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:50:54.492Z',
                        updatedAt: '2024-07-29T16:21:24.677Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 3,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Startups',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6mmXt8ucuZeUhSL5FbrXlL/8eb69102c70d55fcd3d3d1c0cb2caf1f/Icon.svg',
                          details: {
                            size: 1226,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Startups',
                    shortDescription:
                      'Go global with our Multi-currency Business Account and Debit Card',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Start-up ',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '77ymgeHSWtah5V9iCQwBt3',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:31:58.720Z',
                    updatedAt: '2024-07-09T15:54:19.070Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 212',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'ihmbvjgL0ILKarfwA7Fgn',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:54:14.728Z',
                        updatedAt: '2024-07-29T16:21:44.485Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Scale Up Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/ihmbvjgL0ILKarfwA7Fgn/810f283d8f0cc3a9825cff8faa6e1d76/Icon-1.svg',
                          details: {
                            size: 2728,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-1.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Mid-Size Companies',
                    shortDescription:
                      'Elevate your operations with integrated Expense Management ',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Scale-up',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2cNiiUM2hX9JgquEUWdYpJ',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:01.735Z',
                    updatedAt: '2024-07-09T15:54:52.131Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 213',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6PgcXgEuxKwVsbul6nYLt',
                        type: 'Asset',
                        createdAt: '2024-07-09T15:54:48.681Z',
                        updatedAt: '2024-07-29T16:22:04.818Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Bank icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6PgcXgEuxKwVsbul6nYLt/f14d82a86a1be34fe2630c43c4609f09/Icon-2.svg',
                          details: {
                            size: 1679,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-2.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Enterprise',
                    shortDescription:
                      'Navigate complex markets confidently with our FX & Treasury Management',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Company-Size/Enterprises',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '2jDHpMsTE5ozGf7T4ZtSck',
              type: 'Entry',
              createdAt: '2024-07-09T15:33:31.397Z',
              updatedAt: '2024-07-09T15:33:31.397Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 22',
              subSectionTitle: 'BY USE CASE',
              linkType: '_blank',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6ioRXfzNjEtG7HzlILcAhr',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:23.698Z',
                    updatedAt: '2024-07-09T16:01:14.989Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 221',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5l2MqOuqt8S7a65XB0IYHI',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:01:11.118Z',
                        updatedAt: '2024-07-29T16:22:36.530Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'User icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5l2MqOuqt8S7a65XB0IYHI/fa10cd9f8f61dc6fd69d5e55a42a1b11/Icon-3.svg',
                          details: {
                            size: 898,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-3.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Creator Economy',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Creator-Economy',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1vUy3HgabQoaQnv5a7TouZ',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:33.069Z',
                    updatedAt: '2024-07-09T16:01:36.729Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 222',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'cO1lTWlTTiVMNk4n1mwIM',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:01:33.128Z',
                        updatedAt: '2024-07-29T16:22:57.820Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Document icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/cO1lTWlTTiVMNk4n1mwIM/5985b31e0d969caff56c687a85fde14c/Icon-4.svg',
                          details: {
                            size: 1109,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-4.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Global Payroll',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Global-Payroll',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '471DzKgwQrwTtb1jy0ZtAd',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:41.985Z',
                    updatedAt: '2024-07-09T16:02:05.124Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 223',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5Tuf9XwYoioAtsW9OMoU68',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:01.352Z',
                        updatedAt: '2024-07-29T16:23:16.798Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Cog Alt Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5Tuf9XwYoioAtsW9OMoU68/5f7ea04bae7cde52c67d88511408e2a5/Icon-5.svg',
                          details: {
                            size: 1329,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-5.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Infrastructure & Construction',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Construction',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6nVffhU1QkLdqBtuT5tP4Y',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:32:51.293Z',
                    updatedAt: '2024-07-09T16:02:22.607Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 224',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5QcE7nEuNFPXV8UQffMAGE',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:19.520Z',
                        updatedAt: '2024-07-29T16:23:37.075Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Truck icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5QcE7nEuNFPXV8UQffMAGE/e93adf1e96d7b861c41b19a217952157/Icon-6.svg',
                          details: {
                            size: 1308,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-6.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Logistics & Distribution',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Logistics',
                  },
                },
              ],
              linkedPagesReference2: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1zurgyJCpoUwyZCZ0M1UzA',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:02.853Z',
                    updatedAt: '2024-07-09T16:02:42.692Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 225',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'N5PXm6LItvXH5aAqhyESo',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:39.797Z',
                        updatedAt: '2024-07-29T16:23:57.903Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Store icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/N5PXm6LItvXH5aAqhyESo/35377e87297ed2dd613456f05ae67290/Icon-7.svg',
                          details: {
                            size: 2072,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-7.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Marketplaces',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Marketplaces',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '7gJaYB0b7AhL0jNby90vW8',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:12.684Z',
                    updatedAt: '2024-07-09T16:03:02.067Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 226',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6tt3wU0yIvqQjT3Qee6Iig',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:02:59.114Z',
                        updatedAt: '2024-07-29T16:24:17.336Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Factory icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6tt3wU0yIvqQjT3Qee6Iig/b9593de7b7d060450a78065147a9b59f/Icon-8.svg',
                          details: {
                            size: 2998,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-8.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Manufacturing',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Manufacturing',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6TqkmWznhNGLqeRLCjyjT5',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:33:25.273Z',
                    updatedAt: '2024-07-09T16:03:20.048Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 227',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3eufhj78CbLuSSPvs87Q4O',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:03:17.012Z',
                        updatedAt: '2024-07-29T16:24:42.568Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Desktop Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3eufhj78CbLuSSPvs87Q4O/ad1992bf721db65a8a47d87a3d573afe/Icon-9.svg',
                          details: {
                            size: 754,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-9.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Online Retail',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Use-Cases/Online-Retail',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '5kodr8H85wjbTitLXqKcy',
              type: 'Entry',
              createdAt: '2024-07-09T15:36:53.317Z',
              updatedAt: '2024-07-09T16:06:41.831Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 23',
              subSectionTitle: 'BY INDUSTRIES',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '42epo1TtIWpCWXkxj1le6I',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:35:46.316Z',
                    updatedAt: '2024-07-09T16:03:50.177Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 231',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3OK56A5aDcApVRsklglXim',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:03:47.503Z',
                        updatedAt: '2024-07-29T16:25:49.539Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Love icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3OK56A5aDcApVRsklglXim/a99f240df77a602448833fd591f020ce/Icon-10.svg',
                          details: {
                            size: 643,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-10.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Charities & NGOs',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Charities-and-Non-Govermental-Organisations',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1qFY1eqL5KHyKH1nrKJ8ci',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:35:57.041Z',
                    updatedAt: '2024-07-09T16:04:13.069Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 232',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '7lreJ3Zl5q4t46TntivtZu',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:08.649Z',
                        updatedAt: '2024-07-29T16:26:06.066Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'School icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/7lreJ3Zl5q4t46TntivtZu/833f48f5a0e461393a14272592157c94/Icon-11.svg',
                          details: {
                            size: 1151,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-11.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Educational Institution',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Educational-Institutions',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2kGYWwxn0kOhmB6vCfWGcH',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:07.862Z',
                    updatedAt: '2024-07-09T16:04:31.457Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 233',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6Ft2MShev6RfUCX0Ttti8I',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:27.493Z',
                        updatedAt: '2024-07-29T16:26:24.258Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Export icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6Ft2MShev6RfUCX0Ttti8I/23dc3e05f4a822d1d44d715104310cfc/Icon-12.svg',
                          details: {
                            size: 942,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-12.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Exporters',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Exporters',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6670fo0nefiodbxvlVND1x',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:13.249Z',
                    updatedAt: '2024-07-09T16:04:51.009Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 234',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '17lxoPg1iJa7AUkEyNh54E',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:04:48.353Z',
                        updatedAt: '2024-07-29T16:26:43.465Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Health icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/17lxoPg1iJa7AUkEyNh54E/302e4078f2654f5c645fc65583fe830b/Icon-13.svg',
                          details: {
                            size: 1109,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-13.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Health & Pharmaceutical',
                    linkType: '_self',
                  },
                },
              ],
              linkedPagesReference2: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '62Z11bO6q0aAiZcBBIbadD',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:22.879Z',
                    updatedAt: '2024-07-09T16:05:16.587Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 235',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'uZ0E9uBhnZhm6M6xEsWm1',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:05:13.659Z',
                        updatedAt: '2024-07-29T16:33:12.932Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 3,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Import icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/uZ0E9uBhnZhm6M6xEsWm1/644e682d528c4ea1d09e8ee28803969a/Icon__2_.svg',
                          details: {
                            size: 870,
                            image: { width: 45, height: 44 },
                          },
                          fileName: 'Icon (2).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Importers',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Importers',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2IyXGc5AExQvJRskydhNNi',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:34.589Z',
                    updatedAt: '2024-07-09T16:05:39.825Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 236',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '7KuN5RDS7eI3mxdHdel6pU',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:05:36.772Z',
                        updatedAt: '2024-07-29T16:33:36.928Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Video icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/7KuN5RDS7eI3mxdHdel6pU/427183b187f8e07eda87af431a7c0321/Icon-14.svg',
                          details: {
                            size: 788,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-14.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Media & Communications',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Telecommunications',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5CJi4mZ1qEznzYmp3cRcj6',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:36:46.410Z',
                    updatedAt: '2024-07-09T16:06:38.725Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 237',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5EXlAtU0UzYXTSnfFlblmj',
                        type: 'Asset',
                        createdAt: '2024-07-09T16:06:35.635Z',
                        updatedAt: '2024-07-29T16:33:57.851Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Plane icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5EXlAtU0UzYXTSnfFlblmj/15d832d6943e5dbf0f9460408780d202/Icon-16.svg',
                          details: {
                            size: 1386,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-16.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Travel & Tourism',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/Solutions/Industries/Travel-and-Tourism',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: '5ps6oLpTuPZM2bpCfqySJm',
        type: 'Entry',
        createdAt: '2024-07-09T15:39:07.372Z',
        updatedAt: '2024-07-09T15:39:07.372Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 1,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'headerColumn' },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 5',
        id: 'psNavHeaderColumn5',
        title: 'Company',
        headerSubsectionReference: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '1sYuJZhRaVqi29ffwor4j5',
              type: 'Entry',
              createdAt: '2024-07-09T15:37:41.297Z',
              updatedAt: '2024-07-09T15:37:41.297Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 51',
              subSectionTitle: 'Company',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '3R0T5s6HSwUmOtFKADIBgz',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:21.894Z',
                    updatedAt: '2024-07-10T11:36:05.240Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 511',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5kpkXnudi7HKcWQXCbqLrL',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:35:58.359Z',
                        updatedAt: '2024-07-29T16:40:38.417Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Verto Circle Icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5kpkXnudi7HKcWQXCbqLrL/5345557a2e68b2f77a90a77adb0fd406/Icon.svg',
                          details: {
                            size: 436,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'About Verto',
                    shortDescription: 'Learn more about Verto',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/About-Us',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'hy2uFh0N5g33j8ZLXjeSg',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:29.591Z',
                    updatedAt: '2024-07-10T11:36:26.634Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 512',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5992I98Y0TCHdudqyYKU4a',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:36:21.882Z',
                        updatedAt: '2024-07-29T16:41:01.003Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Verto careers',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5992I98Y0TCHdudqyYKU4a/067738c4252601faa9e1a9e7bf264daa/Icon-1.svg',
                          details: {
                            size: 2053,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-1.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Careers',
                    shortDescription: 'Join our awesome team',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/Careers',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4gATifxKFQA2coAo1NT98X',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:38.253Z',
                    updatedAt: '2024-07-10T11:37:49.234Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 513',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6snGpydGRyErhtj7pVlccs',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:37:31.244Z',
                        updatedAt: '2024-07-29T16:41:23.839Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Group icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6snGpydGRyErhtj7pVlccs/ba2be3cefdcfa61db1ea84ea58443433/Icon-2.svg',
                          details: {
                            size: 1716,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-2.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Partner',
                    shortDescription: 'Join our partnership program',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Company/Partners',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference2: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: 'RHLn1J5LATXIPPqbx9PNC',
              type: 'Entry',
              createdAt: '2024-07-09T15:38:16.245Z',
              updatedAt: '2024-07-09T15:38:16.245Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 52',
              subSectionTitle: 'Resources',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5JRYP40XdNRr3AFiwkUMe8',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:37:54.344Z',
                    updatedAt: '2024-07-10T11:38:21.517Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 521',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'nstogbT6X6tSFC975HAqi',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:38:17.496Z',
                        updatedAt: '2024-07-29T16:41:50.303Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Edit icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/nstogbT6X6tSFC975HAqi/3a7bf4b20675fc46ec7eeea00277d72a/Icon-3.svg',
                          details: {
                            size: 1797,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-3.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Blog',
                    shortDescription: 'Explore industry and product insight',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Blog',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1WEY4krxVQKCGv5jaMiKGi',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:05.981Z',
                    updatedAt: '2024-07-10T11:38:40.838Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 522',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3vpJUFLCkSj9oqVdWfCRR8',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:38:37.580Z',
                        updatedAt: '2024-07-29T16:42:10.338Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Lifebuoy icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3vpJUFLCkSj9oqVdWfCRR8/d133566d54ae2d7fb2e9296e201f5b21/Icon-4.svg',
                          details: {
                            size: 2018,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-4.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Support',
                    shortDescription: 'Connect with our support team',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Support',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5iOy42o2RQDstW4eqASnI5',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:14.082Z',
                    updatedAt: '2024-07-10T11:39:07.473Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 523',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '2ujAwqHOuahU0kgOKGjBG0',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:04.397Z',
                        updatedAt: '2024-07-29T16:42:28.508Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Document icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/2ujAwqHOuahU0kgOKGjBG0/da1cd6c7cf1486abe524710add92709d/Icon-5.svg',
                          details: {
                            size: 1109,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-5.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Whitepapers & Reports',
                    shortDescription: 'Explore exclusive research and reports',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Resources/Whitepapers-and-Reports',
                  },
                },
              ],
            },
          },
        ],
        headerSubsectionReference3: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '2Ie0scikvixMw1tLLgU6kM',
              type: 'Entry',
              createdAt: '2024-07-09T15:39:02.596Z',
              updatedAt: '2024-07-09T15:39:02.596Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 53',
              subSectionTitle: 'News & Media',
              linkType: '_self',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2G9k0pSgJOYC6jg4oZq2sY',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:29.543Z',
                    updatedAt: '2024-07-10T11:39:36.657Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 531',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'alf7igqsNlzgA6EVcTorX',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:32.400Z',
                        updatedAt: '2024-07-29T16:42:55.785Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Receipt icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/alf7igqsNlzgA6EVcTorX/f038d4dbf902838fb3f60dea46ccb4d9/Icon-6.svg',
                          details: {
                            size: 1378,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-6.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Newsroom',
                    shortDescription: 'Latest news on Verto',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Newsroom',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: 'ckrJ5uBge3dZnsPTHwZSA',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:38.465Z',
                    updatedAt: '2024-07-10T11:39:56.167Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 532',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6mpEpMfztUMINSXHHrtVW5',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:39:53.375Z',
                        updatedAt: '2024-07-29T16:43:11.983Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Events icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6mpEpMfztUMINSXHHrtVW5/22b1adb9d4a438df9161eaf56a78e672/Icon-7.svg',
                          details: {
                            size: 2685,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-7.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Events',
                    shortDescription: 'Meet our team at an event near you',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Events',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '7tY9i08Xcdy79V9uWBMLDB',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:47.508Z',
                    updatedAt: '2024-07-10T11:40:13.464Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 533',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: 'zAZiKeCGqCnnGf3oVOexH',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:40:09.941Z',
                        updatedAt: '2024-07-29T16:43:32.210Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Microphone icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/zAZiKeCGqCnnGf3oVOexH/43f9002c1db0c550bbe530c22737fdbb/Icon-8.svg',
                          details: {
                            size: 1645,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-8.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Webinars & Podcasts',
                    shortDescription: 'Listen to global business leaders',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Webinars-and-Podcasts',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6BTCQ2NJZrVpqQIPjJsA5X',
                    type: 'Entry',
                    createdAt: '2024-07-09T15:38:56.692Z',
                    updatedAt: '2024-07-10T11:40:30.755Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Subsection 534',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6AEtgQwFc2gK0uJoq1ZX3w',
                        type: 'Asset',
                        createdAt: '2024-07-10T11:40:26.441Z',
                        updatedAt: '2024-07-29T16:43:57.536Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 2,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Story icon',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6AEtgQwFc2gK0uJoq1ZX3w/c0be3b43352d0b90ef32d4a1a33676c6/Icon-9.svg',
                          details: {
                            size: 1252,
                            image: { width: 44, height: 44 },
                          },
                          fileName: 'Icon-9.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Customer Stories',
                    shortDescription: 'Success stories from Verto users',
                    linkType: '_self',
                    redirectLink:
                      'https://verto.co/About-Us/Media-and-Events/Customer-Stories',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: '12cx8Datyan1C8y2tAPAqg',
        type: 'Entry',
        createdAt: '2024-08-02T07:21:37.266Z',
        updatedAt: '2024-08-02T07:39:41.943Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 3,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'headerColumn' },
        },
        locale: 'en-US',
      },
      fields: {
        internalName: 'PS Nav Header Column 6',
        id: 'psNavHeaderColumn6',
        title: 'Coverage',
        subsectionHeader: 'Currencies',
        headerSubsectionReference: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '2s1SZdWNlrC4Ls1QirzmbL',
              type: 'Entry',
              createdAt: '2024-08-02T07:24:37.106Z',
              updatedAt: '2024-08-02T07:35:10.680Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 61',
              linkType: '_self',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '3bLS3gjBpc5wKp9udWn1HH',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:21:07.233Z',
                    updatedAt: '2023-03-23T18:05:40.416Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.1',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4LcSB7qcUPHfktJgpojXT1',
                        type: 'Asset',
                        createdAt: '2022-12-27T05:50:39.440Z',
                        updatedAt: '2023-03-23T13:50:00.389Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 13,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Currency Nigerian Naira Icon',
                        description: 'Currency Nigerian Naira Icon',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4LcSB7qcUPHfktJgpojXT1/8d28a22776a44259ac147668750ee939/Flags_61_.svg',
                          details: {
                            size: 459,
                            image: { width: 33, height: 32 },
                          },
                          fileName: 'Flags(61).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Nigerian Naira',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/Africa/Nigerian-Naira',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2KjoABcVFNUgacqJY2kNIO',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:21:35.486Z',
                    updatedAt: '2023-03-23T18:05:49.018Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.2',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6XmlQvgHsaS4CliEDkFK6m',
                        type: 'Asset',
                        createdAt: '2022-11-18T10:57:19.014Z',
                        updatedAt: '2023-03-23T13:48:28.328Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 14,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'US Dollar Flag',
                        description: 'US Dollar Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6XmlQvgHsaS4CliEDkFK6m/e332d14379d06f765c7d7c283b553f6c/Flags.svg',
                          details: {
                            size: 1613,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags.svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'US Dollars',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/North-America/US-Dollar',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '4W8gFIUQKRVWcqXtyu7uSH',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:22:10.962Z',
                    updatedAt: '2023-09-05T16:00:12.515Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.3',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '581w0NbB5dBYognuJKvHnP',
                        type: 'Asset',
                        createdAt: '2022-12-27T05:50:38.430Z',
                        updatedAt: '2023-03-23T13:50:01.448Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Currency Kenyan Shilling Icon',
                        description: 'Currency Kenyan Shilling Icon',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/581w0NbB5dBYognuJKvHnP/09248ae5add85e8901164f38c827638f/Flags_59_.svg',
                          details: {
                            size: 2689,
                            image: { width: 33, height: 32 },
                          },
                          fileName: 'Flags(59).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Kenyan Shillings',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/Africa/Kenyan-Shilling',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5FpZlMFaG7L9H1aSjQuNI2',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:22:46.348Z',
                    updatedAt: '2023-03-23T18:10:48.203Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.4',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3ihnAFDWQ40Q8KQABCv8xw',
                        type: 'Asset',
                        createdAt: '2023-02-16T12:40:10.000Z',
                        updatedAt: '2023-03-23T13:55:40.336Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Japan Flag',
                        description: 'Japan Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3ihnAFDWQ40Q8KQABCv8xw/2796af906291b16dfd8abc8052a7185f/Flags__33_.svg',
                          details: {
                            size: 374,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (33).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Japanese Yen',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/Asia/Japanese-Yen',
                  },
                },
              ],
            },
          },
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '7ybsPFOoUgNVYeSGJg8GJg',
              type: 'Entry',
              createdAt: '2024-08-02T07:25:39.208Z',
              updatedAt: '2024-08-02T07:35:00.504Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 62',
              linkType: '_self',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5dL6yGaGBJKIaKQ3pPUrH0',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:23:38.182Z',
                    updatedAt: '2023-06-26T07:14:08.825Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.5',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5sZdYtTGpaaJbaUX0kMj4T',
                        type: 'Asset',
                        createdAt: '2022-11-18T10:57:39.734Z',
                        updatedAt: '2024-01-02T11:38:40.184Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 16,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'United Kingdom',
                        description: 'United Kingdom Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5sZdYtTGpaaJbaUX0kMj4T/f1bb196396dadc17fea3cda6b3df5218/Flags_30_.svg',
                          details: {
                            size: 1123,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags(30).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'British Pound',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/Europe/Pound-Sterling',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2cqTq3dFqxqUOfAzq0kk9o',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:24:21.461Z',
                    updatedAt: '2023-03-23T18:11:08.850Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 3,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.6',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4eMasbO1cOeUFoRUcDDiH6',
                        type: 'Asset',
                        createdAt: '2022-12-27T05:50:39.964Z',
                        updatedAt: '2023-03-23T13:50:02.256Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 13,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Currency South African Rand Icon',
                        description: 'Currency South African Rand Icon',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4eMasbO1cOeUFoRUcDDiH6/b13ac53d9bec1192fadd7631d3d6a9b2/Flags_62_.svg',
                          details: {
                            size: 1207,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags(62).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'South African Rand',
                    linkType: '_self',
                    redirectLink:
                      'Coverage/Currencies/Africa/South-African-Rand',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1Cob5KxvzuigLcjgSdsjr4',
                    type: 'Entry',
                    createdAt: '2023-01-19T08:25:10.762Z',
                    updatedAt: '2023-03-23T18:11:18.867Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 4,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.7',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5QjjeVqex2SQ9zvvIb6B65',
                        type: 'Asset',
                        createdAt: '2023-02-16T11:36:20.405Z',
                        updatedAt: '2023-03-23T13:55:35.339Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'China Flag',
                        description: 'China Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5QjjeVqex2SQ9zvvIb6B65/92d26efd5dbfd54c5670774ce3eade49/Flags__2_.svg',
                          details: {
                            size: 957,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (2).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Chinese Yuan',
                    linkType: '_self',
                    redirectLink: 'Coverage/Currencies/Asia/Chinese-Yuan',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5hRpYrE2jlOrpOet0wIXTj',
                    type: 'Entry',
                    createdAt: '2023-06-27T09:58:04.625Z',
                    updatedAt: '2023-06-27T09:58:04.625Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.2.8',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6cbGV7VT2BtDCLT8NDElZn',
                        type: 'Asset',
                        createdAt: '2023-06-27T09:54:08.984Z',
                        updatedAt: '2023-06-27T09:54:08.984Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Globe',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6cbGV7VT2BtDCLT8NDElZn/ea63213e0ef2e00986256b4d2444697f/117965.png',
                          details: {
                            size: 14942,
                            image: { width: 512, height: 512 },
                          },
                          fileName: '117965.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Explore more Currencies',
                    linkType: '_self',
                    redirectLink: 'https://verto.co/Coverage/Currencies',
                  },
                },
              ],
            },
          },
        ],
        subsectionHeader2: 'Countries',
        headerSubsectionReference2: [
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '2Pc6POHL1k8GHrI2c2gOn3',
              type: 'Entry',
              createdAt: '2024-08-02T07:29:46.665Z',
              updatedAt: '2024-08-02T07:38:59.161Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 63',
              subSectionTitle: 'Company',
              linkType: '_self',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '7v4NNclfPhqAK1hPIIKZ7w',
                    type: 'Entry',
                    createdAt: '2023-06-20T07:33:32.130Z',
                    updatedAt: '2023-06-20T07:33:32.130Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.1',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4LcSB7qcUPHfktJgpojXT1',
                        type: 'Asset',
                        createdAt: '2022-12-27T05:50:39.440Z',
                        updatedAt: '2023-03-23T13:50:00.389Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 13,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Currency Nigerian Naira Icon',
                        description: 'Currency Nigerian Naira Icon',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4LcSB7qcUPHfktJgpojXT1/8d28a22776a44259ac147668750ee939/Flags_61_.svg',
                          details: {
                            size: 459,
                            image: { width: 33, height: 32 },
                          },
                          fileName: 'Flags(61).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Nigeria',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Africa/Nigeria',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2lW9jxrxbtUZjNjP0KgLRn',
                    type: 'Entry',
                    createdAt: '2023-06-20T10:23:28.262Z',
                    updatedAt: '2023-06-20T10:23:28.262Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.2',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '1oivD06kF6l6OwJULAk2ow',
                        type: 'Asset',
                        createdAt: '2023-02-16T06:59:01.328Z',
                        updatedAt: '2023-12-22T08:49:49.598Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 13,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'United States of America',
                        description: 'United States of America Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/1oivD06kF6l6OwJULAk2ow/90b6c13a501c324f24a6b9134f4db337/Flags__11_.svg',
                          details: {
                            size: 1649,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (11).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'United States of America',
                    linkType: '_self',
                    redirectLink:
                      'Coverage/Countries/NorthAmerica/UnitedStatesofAmerica',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2McrpwB3AceZsCKpwale0F',
                    type: 'Entry',
                    createdAt: '2023-06-20T11:50:29.457Z',
                    updatedAt: '2023-06-20T11:50:29.457Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.3',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '581w0NbB5dBYognuJKvHnP',
                        type: 'Asset',
                        createdAt: '2022-12-27T05:50:38.430Z',
                        updatedAt: '2023-03-23T13:50:01.448Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Currency Kenyan Shilling Icon',
                        description: 'Currency Kenyan Shilling Icon',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/581w0NbB5dBYognuJKvHnP/09248ae5add85e8901164f38c827638f/Flags_59_.svg',
                          details: {
                            size: 2689,
                            image: { width: 33, height: 32 },
                          },
                          fileName: 'Flags(59).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Kenya',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Africa/Kenya',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '1mgOwZAPxxh7QDlXnyhplI',
                    type: 'Entry',
                    createdAt: '2023-06-20T11:51:51.554Z',
                    updatedAt: '2023-06-20T11:51:51.554Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.4',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '3ihnAFDWQ40Q8KQABCv8xw',
                        type: 'Asset',
                        createdAt: '2023-02-16T12:40:10.000Z',
                        updatedAt: '2023-03-23T13:55:40.336Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Japan Flag',
                        description: 'Japan Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/3ihnAFDWQ40Q8KQABCv8xw/2796af906291b16dfd8abc8052a7185f/Flags__33_.svg',
                          details: {
                            size: 374,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (33).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'Japan',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Asia/Japan',
                  },
                },
              ],
            },
          },
          {
            metadata: { tags: [] },
            sys: {
              space: {
                sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' },
              },
              id: '6VVSi1sNCTuFN0reV9jPox',
              type: 'Entry',
              createdAt: '2024-08-02T07:29:53.455Z',
              updatedAt: '2024-08-02T07:39:35.602Z',
              environment: {
                sys: { id: 'master', type: 'Link', linkType: 'Environment' },
              },
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'headerSubsection',
                },
              },
              locale: 'en-US',
            },
            fields: {
              internalName: 'Nav Header Subsection 64',
              linkType: '_self',
              redirectLink: 'https://www.google.com',
              linkedPagesReferences: [
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '5nDV4bZTdyr8d7Ugvi33qs',
                    type: 'Entry',
                    createdAt: '2023-06-20T07:35:29.179Z',
                    updatedAt: '2023-06-20T11:57:10.127Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.5',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5sZdYtTGpaaJbaUX0kMj4T',
                        type: 'Asset',
                        createdAt: '2022-11-18T10:57:39.734Z',
                        updatedAt: '2024-01-02T11:38:40.184Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 16,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'United Kingdom',
                        description: 'United Kingdom Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5sZdYtTGpaaJbaUX0kMj4T/f1bb196396dadc17fea3cda6b3df5218/Flags_30_.svg',
                          details: {
                            size: 1123,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags(30).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'United Kingdom',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Europe/UnitedKingdom',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2bOT1mUP9vkjHVf4HnzIWR',
                    type: 'Entry',
                    createdAt: '2023-06-20T11:58:07.488Z',
                    updatedAt: '2023-06-20T11:58:07.488Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.6',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '4uHVdDNr1Tw5Eqlu12PTb2',
                        type: 'Asset',
                        createdAt: '2023-02-14T10:36:03.916Z',
                        updatedAt: '2023-05-02T05:42:30.339Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 13,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'South Africa',
                        description: 'South Africa Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/4uHVdDNr1Tw5Eqlu12PTb2/63813106fdbef65e548c318d06f0c421/Flags__40_.svg',
                          details: {
                            size: 1205,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (40).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'South Africa',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Africa/SouthAfrica',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '2RHRm9tcJt1EEVR6uMKhtd',
                    type: 'Entry',
                    createdAt: '2023-06-20T12:01:40.466Z',
                    updatedAt: '2023-06-20T12:01:40.466Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.7',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '5QjjeVqex2SQ9zvvIb6B65',
                        type: 'Asset',
                        createdAt: '2023-02-16T11:36:20.405Z',
                        updatedAt: '2023-03-23T13:55:35.339Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 12,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'China Flag',
                        description: 'China Flag',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/5QjjeVqex2SQ9zvvIb6B65/92d26efd5dbfd54c5670774ce3eade49/Flags__2_.svg',
                          details: {
                            size: 957,
                            image: { width: 32, height: 32 },
                          },
                          fileName: 'Flags (2).svg',
                          contentType: 'image/svg+xml',
                        },
                      },
                    },
                    subSectionTitle: 'China',
                    linkType: '_self',
                    redirectLink: 'Coverage/Countries/Asia/China',
                  },
                },
                {
                  metadata: { tags: [] },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: '2rrb5ka4jpe4',
                      },
                    },
                    id: '6YViuACg0j5iZhKoW3qvdT',
                    type: 'Entry',
                    createdAt: '2023-06-28T10:44:09.964Z',
                    updatedAt: '2023-06-28T10:44:09.964Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment',
                      },
                    },
                    revision: 1,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'headerSubsection',
                      },
                    },
                    locale: 'en-US',
                  },
                  fields: {
                    internalName: 'Nav Header Sub section 4.3.8',
                    subSectionIcon: {
                      metadata: { tags: [] },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: '2rrb5ka4jpe4',
                          },
                        },
                        id: '6cbGV7VT2BtDCLT8NDElZn',
                        type: 'Asset',
                        createdAt: '2023-06-27T09:54:08.984Z',
                        updatedAt: '2023-06-27T09:54:08.984Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment',
                          },
                        },
                        revision: 1,
                        locale: 'en-US',
                      },
                      fields: {
                        title: 'Globe',
                        description: '',
                        file: {
                          url: '//images.ctfassets.net/2rrb5ka4jpe4/6cbGV7VT2BtDCLT8NDElZn/ea63213e0ef2e00986256b4d2444697f/117965.png',
                          details: {
                            size: 14942,
                            image: { width: 512, height: 512 },
                          },
                          fileName: '117965.png',
                          contentType: 'image/png',
                        },
                      },
                    },
                    subSectionTitle: 'Explore more Countries',
                    linkType: '_self',
                    redirectLink: 'https://verto.co/Coverage/Countries',
                  },
                },
              ],
            },
          },
        ],
        viewType: '1',
      },
    },
  ],
  button: [
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: '3MkNo4lVVSY6eSF63rmmj6',
        type: 'Entry',
        createdAt: '2023-01-19T08:59:05.104Z',
        updatedAt: '2023-02-13T12:16:27.161Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 2,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'button' },
        },
        locale: 'en-US',
      },
      fields: {
        buttonId: 'login',
        buttonTitle: 'Login',
        buttonText: 'Login',
        actionType: '_self',
        screenName: 'Login Screen',
        redirectLink: 'https://exchange.verto.co/auth/login',
      },
    },
    {
      metadata: { tags: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: '2rrb5ka4jpe4' } },
        id: 'YE8NTzC1durNYtdZklB8W',
        type: 'Entry',
        createdAt: '2022-12-27T08:24:42.314Z',
        updatedAt: '2024-02-27T16:31:04.320Z',
        environment: {
          sys: { id: 'master', type: 'Link', linkType: 'Environment' },
        },
        revision: 10,
        contentType: {
          sys: { type: 'Link', linkType: 'ContentType', id: 'button' },
        },
        locale: 'en-US',
      },
      fields: {
        buttonId: 'getStarted',
        buttonTitle: 'Get started',
        buttonText: 'Get started',
        actionType: '_self',
        screenName: 'Login/Signup',
        redirectLink: 'https://exchange.verto.co/auth/register',
      },
    },
  ],
};
